import { showErrorFromMutation } from "@/shared/utils/toast";
import {
  fetchSuperAdminOrganizationsList,
  fetchSuperAdminOrgUsers,
} from "../api/superadminApi";
import { useQuery } from "@tanstack/react-query";

// Fetch organizations list for super admin
export const useFetchSuperAdminOrganizationsList = () => {
  return useQuery({
    queryKey: ["super-admin-organizations-list"],
    queryFn: fetchSuperAdminOrganizationsList,
    onError: (error) => {
      showErrorFromMutation(
        error,
        error.message || "Failed to fetch organizations list. Please try again.",
      );
    },
  });
};

export const useFetchSuperAdminOrgUsers = (orgId, options = {}) => {
  const { limit = 100, offset = 0, enabled = true } = options;
  return useQuery({
    queryKey: ["super-admin-org-users", orgId, limit, offset],
    queryFn: () => fetchSuperAdminOrgUsers(orgId, { limit, offset }),
    enabled: Boolean(orgId) && enabled,
    onError: (error) => {
      showErrorFromMutation(error, error.message || "Failed to load members.");
    },
  });
};